export const COLUMN_NAMES = {
    DATE: 'date',
    NAME: 'name',
    TYPE: 'type',
    ACTIONS: 'actions',
};
